/*
 * getters.js
 *
 * Description: Holds global Getters (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
export const value = state => {
    return state.value;
};



// WEBPACK FOOTER //
// ./src/store/getters.js